<template>
  <section id="tools" class="resume">
    <div class="resume-content mt-5">
      <p class="headline__subtitle animate-headline">
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="currentColor">
          <path d="M5.6,12.6c-0.5-0.8-0.7-2.4-1.7-3.5c-1-1-2.7-1.2-3.5-1.7C-0.1,7-0.1,6,0.4,5.6c0.8-0.5,2.3-0.6,3.5-1.8
            C5,2.8,5.1,1.2,5.6,0.4C6-0.1,7-0.1,7.4,0.4c0.5,0.8,0.7,2.4,1.8,3.5c1.2,1.2,2.6,1.2,3.5,1.7c0.6,0.4,0.6,1.4,0,1.7
            C11.8,7.9,10.2,8,9.1,9.1c-1,1-1.2,2.7-1.7,3.5C7,13.1,6,13.1,5.6,12.6z" />
        </svg>
        <span>Tools</span>
      </p>

      <div class="tools-grid">
        <div v-for="(tool, index) in tools" :key="index" class="tools-card">
          <img class="tools-icon" :src="tool.icon" :alt="tool.name + ' Icon'" />
          <h6 class="tools-caption">{{ tool.name }}</h6>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ResumeSection',
  data() {
    return {
      tools: [
        { name: 'Cypress', icon: require('@/assets/images/cypress-logo.png') },
        { name: 'Playwright', icon: require('@/assets/images/playwright.png') },
        { name: 'Postman', icon: require('@/assets/images/postman.png') },
        { name: 'K6', icon: require('@/assets/images/k6.png') },
        { name: 'Qase.io', icon: require('@/assets/images/qase.jpeg') },
        { name: 'Clickup', icon: require('@/assets/images/clickup.png') },
        { name: 'Jam', icon: require('@/assets/images/jam.jpeg') },
        { name: 'Mocha & Chai', icon: require('@/assets/images/Mocha.svg')}
      ],
    };
  },
};
</script>
<style>
.headline__subtitle {
  display: inline-flex;
  align-items: center;
  height: 3.4rem;
  padding: 0 1.4rem;
  border-radius: var(--_radius-s);
  border: 1px solid var(--stroke-elements);
  font: 700 18px/3.3rem var(--_font-default);
  margin-bottom: 1rem;
  /* color: #fff; */
}

.resume-content {
  margin-top: 20px;
}

.tools-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  /* Default: 2 kolom */
  gap: 1.5rem;
  margin-top: 1.5rem;
  margin-bottom: 2rem;
  border-radius: var(--_radius-s);


}


@media (min-width: 768px) {
  .tools-grid {
    grid-template-columns: repeat(4, 1fr);
    /* Misal tablet ke atas: 4 kolom */
  }

}

@media (min-width: 1024px) {
  .tools-grid {
    grid-template-columns: repeat(4, 1fr);
    margin-right: 40px;
    /* Misal laptop ke atas: 6 kolom */

  }

  /* .resume-content {
    margin-right: 40px;
  } */
}

/* .tools-card {
  background: rgba(14, 5, 5, 0.079);
  border-radius: 16px;
  padding: 1rem;
  text-align: center;
  transition: transform 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.1);
} */

.tools-card:hover {
  -moz-border-radius: var(--_radius-s);
  border-radius: var(--_radius-s);
  border: none;
  /* transform: translateY(-2px) scale(1.05); */
  /* background: rgba(255, 255, 255, 0.08); */
  box-shadow: 0 0 16px rgb(52, 180, 203);
  /* color: var(--t-accent--dark); */
  /* backdrop-filter: blur(20px); */
}


.tools-icon {
  width: 60px;
  height: 60px;
  object-fit: contain;
  margin: 0 auto 0.5rem;
}

.tools-caption {
  color: var(--t-bright--dark);
  font-size: 14px;
  /* font-weight: 500; */
}
</style>
